import { render, staticRenderFns } from "./DemandePermisPsychotherapeute.vue?vue&type=template&id=044afd0b"
import script from "./DemandePermisPsychotherapeute.vue?vue&type=script&lang=js"
export * from "./DemandePermisPsychotherapeute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports